import React, { useCallback, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import {
  mapDispatchToPropsManagement,
  mapStateToPropsManagement,
  mapToStateToPropsParticipant,
} from "../../../modules/profileManagement";
import ProfileCard from "../../ui-library/ProfileCard/ProfileCard";
import { getFormattedDate } from "../../../modules/utils";
import { withTheme } from "styled-components";
import { TablePopover } from "../../ui-library/TablePopover/TablePopover";
import DefaultTable, { Line } from "../../ui-library/CustomTable/DefaultTable";
import TableDropDown from "../../ui-library/TableDropDown/TableDropDown";
import { useTranslation } from "react-i18next";
import history from "../../../modules/history";

export const ParticipantUsers = (props) => {
  const {
    participantUsers,
    fetchParticipantUsers,
    totalitems,
    searchedParams,
    theme,
    loading,
    resetState,
  } = props;

  const { t } = useTranslation();

  const getData = useCallback(
    (params) => {
      fetchParticipantUsers(params);
    },
    [fetchParticipantUsers]
  );

  useEffect(() => {
    return () => {
      resetState();
    };
  }, []);

  useEffect(() => {
    if (totalitems === null) {
      getData(searchedParams);
    }
  }, [fetchParticipantUsers, totalitems, getData, searchedParams]);

  const defaultProps = {
    headers: [
      { label: t("appText.participantUsers.site") },
      { label: t("appText.participantUsers.participantId") },
      { label: t("appText.participantUsers.study") },
      { label: t("appText.participantUsers.dateSignedUp") },
      { label: t("appText.participantUsers.lastLogin") },
      { label: t("appText.participantUsers.options") },
    ],
    maincolor: theme.success,
    totalitems,
    hasSearch: 1,
    haspagesizefilter: 1,
    haspagination: 1,
    searchedParams,
    loading,
    getData,
  };

  return (
    <div
      data-testid="participant-users"
      className="mt-5"
      style={{ paddingTop: "2em", position: "relative" }}
    >
      <div className="mb-5">
        <ProfileCard
          title={t("appText.participantUsers.header.participantInformation")}
          cardHeader="-green"
          iconClassName="fas fa-users-cog"
          addPadding={true}
        >
          <DefaultTable
            {...{ ...defaultProps }}
            data-testid="participants-table"
          >
            {participantUsers.map((user, index) => (
              <Line key={`user-entry-${index}`}>
                <span>{user.site}</span>
                <span>{user.name || user.userName || "-"}</span>
                <span>
                  <TablePopover description="Studies" data={user.studies} />
                </span>
                <span>{getFormattedDate(user.created)}</span>
                <span>{getFormattedDate(user.lastlogin)}</span>

                <TableDropDown>
                  {[
                    <Dropdown.Item
                      key="3"
                      onClick={() => {
                        history.push(
                          `/admin/caregivers/${user?.userName}/${user?.userId}`
                        );
                      }}
                    >
                      {t("appText.participantUsers.manageCaregivers")}
                    </Dropdown.Item>,
                  ]}
                </TableDropDown>
              </Line>
            ))}
          </DefaultTable>
        </ProfileCard>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsManagement(state),
    ...mapToStateToPropsParticipant(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToPropsManagement
)(withTheme(ParticipantUsers));
